import { api } from "../api";

/**
 * updateInterestPointCrudRequest - Function that updates an interest point
 * /interest-points/{interestPointId}
 * method PUT
 * @async-function
 */
const updateInterestPointCrudRequest = async (
    token: string,
    interestPointId: number,
    data: any
) => {
    const response = await api.put(
        `/interest-points/${interestPointId}`,
        data,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
    return response;
};

export default updateInterestPointCrudRequest;
